module.exports = __webpack_public_path__ + "/441debacd7f3a85ce8a8c6e9dae8f636.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/feature_icons/integrate_icon.svg
 ** module id = 1539
 ** module chunks = 0
 **/